
import React, { useEffect } from 'react';
import MatrixBackground from '../components/MatrixBackground';
import ScanLines from '../components/ScanLines';
import Header from '../components/Header';
import Work from '../components/Work';
import Footer from '../components/Footer';

const WorkPage = () => {
  useEffect(() => {
    // Change title
    document.title = 'Things of Interest | SpecialAgentK';
  }, []);

  return (
    <div className="bg-cyber-black text-cyber-green min-h-screen">
      <MatrixBackground />
      <ScanLines />
      <Header />
      <div className="pt-28">
        <Work />
      </div>
      <Footer />
    </div>
  );
};

export default WorkPage;
